import gql from 'graphql-tag';

export const getBuildReportRank = gql`query($id: Int!) {
    getBuildReportRank(id: $id) {
        Rank
    }
}`;

export const getBuildReport = gql`query($id: Int!) {
    getBuildReport(id: $id) {
        BuilderName,
        TotalScore
    }
}`;

export const getBuildReportListing = gql`query($filter: String!) {
    getBuildReportListing(sortBy: "TotalScore", sortOrder: "DESC", first: 50, filter: $filter) {
        edges {
            node {
                id,
                BuilderName,
                TotalScore,
                ResultPublished
            }
        }
    }
}`;

export const updateBuildReport = gql`mutation($id: Int!, $name: String!, $published: Boolean!){
    updateBuildReport(id: $id, input: {
        BuilderName: $name,
        ResultPublished: $published
    }) {
        message,
        output {
            id
            BuilderName
            ResultPublished
        }
    }
}`;
